import { ArrowUp } from "lucide-react";
import { Reveal } from "./Reveal";
import { Divider, Monogram } from "./Ornaments";
import { COUPLE } from "./data";

const Footer = () => {
    const toTop = () => {
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.8 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer
            data-testid="royal-footer"
            className="relative overflow-hidden border-t border-gold/15 bg-royal-surface/50 pb-12 pt-20"
        >
            <div
                className="pointer-events-none absolute inset-x-0 -top-40 mx-auto h-80 w-[720px] max-w-full rounded-full bg-gold/5 blur-3xl"
                aria-hidden="true"
            />
            <div className="relative mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
                <Reveal>
                    <Monogram className="h-16 w-16" />
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="gold-shimmer animate-shimmer-sweep mt-6 font-script text-4xl sm:text-5xl">
                        {COUPLE.groom} &amp; {COUPLE.bride}
                    </p>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="mt-4 font-cinzel text-[11px] font-semibold uppercase tracking-[0.4em] text-mutedgold">
                        14 &amp; 22 November 2026 · New Delhi
                    </p>
                </Reveal>
                <Reveal delay={0.24}>
                    <Divider className="mt-10" label="॥ श्री गणेशाय नमः ॥" />
                </Reveal>
                <Reveal delay={0.3}>
                    <p className="mt-10 max-w-xl font-royal text-lg italic leading-relaxed text-sand">
                        Your gracious presence and blessings will make our celebration truly
                        memorable.
                    </p>
                </Reveal>

                <Reveal delay={0.36}>
                    <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                        <button
                            data-testid="back-to-top-button"
                            onClick={toTop}
                            className="inline-flex items-center gap-2.5 rounded-full border border-gold/40 px-8 py-3.5 font-cinzel text-[11px] font-bold uppercase tracking-[0.28em] text-gold transition-colors duration-500 hover:bg-gold/10"
                        >
                            <ArrowUp size={14} />
                            Back To Top
                        </button>
                    </div>
                </Reveal>

                <p className="mt-14 font-cinzel text-[10px] uppercase tracking-[0.35em] text-mutedgold/70">
                    With Best Compliments From · All Relatives &amp; Friends
                </p>
            </div>
        </footer>
    );
};

export default Footer;
